import { render } from "./inventoryDetail.vue?vue&type=template&id=c68d2896&scoped=true"
import script from "./inventoryDetail.vue?vue&type=script&lang=js"
export * from "./inventoryDetail.vue?vue&type=script&lang=js"

import "./inventoryDetail.vue?vue&type=style&index=0&id=c68d2896&scoped=true&lang=scss"

import exportComponent from "/home/lcs/jenkins/workspace/v2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c68d2896"]])

export default __exports__